module.exports = __webpack_public_path__ + "media/images/noun_Info_2746478@2x-8284db9f1d1935905f8fd3074c5a4f3c.png";